import { select, Selection } from "d3";
import { render } from "lit";
import { DataDRequest } from "../../../data/DRequest";
import { Entidad } from "../../../data/Entidad";
import { DataModuloMain } from "../../../data/ModuloMain";
import { CFinanzaPagoEnLineaEstado } from "../../../data/entidad/FinanzasEstadoCuenta";
import { _LOCALDATA_GetTutoresDeAlumno } from "../../../data/modulo/Alumno";
import { _DICC_ESCUELA } from "../../../data/modulo/Escuela";
import { _DICC_AGRUPADORES_FULL, _SvFinanzasObtenerListaAgrupadorCargos, _SvFinanzasObtenerListaAgrupadorCargosByIds } from "../../../data/modulo/FinanzaAgrupadorCargos";
import { _DICC_FINANZAS_CARGOS } from "../../../data/modulo/FinanzaCargo";
import { _DICC_ALUMNO_MOVPAGO_FOLIO, _SvAlumnoEdoCtaEliminarDescuento, _SvAlumnoEdoCtaEliminarMorosidad, _SvAlumnoEdoCtaEliminarMovimiento, _SvAlumnoEdoCtaEliminarPagoCompleto, _SvAlumnoEdoCtaNuevosDescuentos, _SvAlumnoEdoCtaObtenerFoliosPagoEnLinea, _SvAlumnoEdoCtaObtenerListaMovimientos } from "../../../data/modulo/FinanzasEstadoCuenta";
import { DataUtil } from "../../../data/util/Util";
import _L from "../../../util/Labels";
import { Button } from "../../controlD3/Button";
import { IConfigCardCollapseExcelExport } from "../../controlD3/CardV1/CardCollapseAdvancedTable";
import { TCARDV2COLL_OnEditOriginEvent } from "../../controlD3/CardV2/CardV2Collapse";
import { CardV2CollapseAdvancedTable, IConfigCardV2CollapseExcelExport } from "../../controlD3/CardV2/CardV2CollapseAdvancedTable";
import { ElementWrapper } from "../../controlD3/ElementWrapper";
import { Fields, FormGenerator } from "../../controlD3/Formulario";
import { MenuFlex } from "../../controlD3/MenuFlexV2";
import { ModalThings } from "../../controlD3/ModalThings";
import { SelectV2 } from "../../controlD3/SelectV2";
import { Table } from "../../controlD3/Tabla";
import { TableUtil } from "../../controlD3/TablaUtil";
import { HTMLImage2Component } from "../../controlWC/HTMLImage2Component";
import { UIUtilFormat } from "../../util/Format";
import { UIUtilIconResources } from "../../util/IconResourses";
import { UIUtilLang } from "../../util/Language";
import { UIUtilStrings } from "../../util/Strings";
import { UIUtilTime } from "../../util/Time";
import { UIUtilGeneral } from "../../util/Util";
import { UIUtilViewData } from "../../util/ViewData";
import { UIUtilViewAlumnoEdoCtaFacturacion } from "../../utilView/AlumnoEdoCta/AlumnoEdoCtaFacturacionForm/FacturacionForm";
import { AlumnoEdoCtaMovDetalleCargoModal } from "../../utilView/AlumnoEdoCta/AlumnoEdoCtaModals/AlumnoEdoCtaMovDetalleCargoModal";
import { _OpenModal_ProcesoPago } from "../../utilView/AlumnoEdoCta/AlumnoEdoCtaProcesoPagoForm/AlumnoEdoCtaProcesoPagoForm";
import { AlumnoEdoCtaUtil } from "../../utilView/AlumnoEdoCta/AlumnoEdoCtaUtil";
import { UIUtilViewCicloEscolar } from "../../utilView/CicloEscolar";
import { UIUtilViewFinanzaCargo } from "../../utilView/FinanzasIngresos/FinanzaCargo";
import { _GetFinanzaCargoForm, TFinanzaCargoDataForm } from "../../utilView/FinanzasIngresos/FinanzaCargoForm";
import { UIUtilViewFinanzasIngresoUtil } from "../../utilView/FinanzasIngresos/FinanzasIngresoUtil";

import CTipoValor = Entidad.CFinanzaCargoTipoValor;
import CCategoriaMov = Entidad.CFinanzaCategoriaMovimiento;
import CTipoPago = Entidad.CTipoPago;
import GetDateValidatorYM = UIUtilTime._GetValidatorDateYM;
import CTableColumns = AlumnoEdoCtaUtil.CTableColumns;

type ICicloEscolar = Entidad.ICicloEscolar;
type IAlumno = Entidad.IAlumno;
type IFinanzaCargo = Entidad.IFinanzaCargo;
type IMovimiento = AlumnoEdoCtaUtil.IMovimientoTbl

interface IPeriodoD extends UIUtilViewData.IPeriodoD {
    EnCicloEscolar: boolean;
}


type IMovimientoDetalle = AlumnoEdoCtaUtil.IMovimientoDetalle;


const columnsTable = [CTableColumns.Periodo, CTableColumns.Descripcion,
CTableColumns.Valor, CTableColumns.Recargo,
CTableColumns.PagoAbono, CTableColumns.Saldo,
CTableColumns.FechaVencimiento, CTableColumns.FechaPago, CTableColumns.MetodoPago]

export class UIPanelCardAlumnosEstadoCuenta extends CardV2CollapseAdvancedTable<IMovimiento, [IAlumno]> {
    private ctrlSelectCicloEscolar: SelectV2<ICicloEscolar, "Id", "monoselect">;
    private ctrlSelectPeriodo: SelectV2<IPeriodoD, "Id", "monoselect">;
    private ctrlMenuInRowAux: MenuFlex;

    /** No usar directamente, usar this.GetCurrentInfoGeneral */
    private infoGeneral: AlumnoEdoCtaUtil.ICurrentData;
    /** No usar directamente, usar this.GetCiclosEscolaresList */
    private ciclosEscolaresList: ICicloEscolar[];
    /** IdAlumno -> Movimientos */
    private movimientosMap: Map<number, IMovimiento[]>;

    constructor(modulo: Entidad.CModulo.PanelFinanzasEdoCuenta) {
        super("", modulo);
        this.movimientosMap = new Map();
    }

    protected CARDCOLLADTAB_Table_GetMenuTop(): Table.ITableMenuTopDefaultOptionConfig[] {
        let opciones: Array<Table.ITableMenuTopDefaultOptionConfig> = [];

        opciones.push({
            Label: "action_addcargo",
            Callback: async () => {
                const form = _GetFinanzaCargoForm(Entidad.CAccionPermiso.Agregar, <TFinanzaCargoDataForm>{ IdEscuela: this.GetIdEscuela() }, "AlumnosEstadoCuenta", this.GetIdEscuela());
                if (!form) return;
                let res = await UIUtilViewFinanzaCargo._OpenModal_FormAddEditCargo(Entidad.CAccionPermiso.Agregar, <TFinanzaCargoDataForm>{ IdEscuela: this.GetIdEscuela() }, form, "AlumnosEstadoCuenta", this.GetIdCurretStudent());
                if (res) {
                    this.UI_UpdateCardData(false, true);
                }
            }
        })
        EvalGenerarCFDIAction(opciones, this.GetEscuela(), this.cardData[0].IdChild, () => this.UI_UpdateCardData(false, true))
        return opciones;
    }

    protected CARDCOLLADTAB_GetExportarConfig(dataTable: IMovimiento[]): IConfigCardV2CollapseExcelExport<any> | Promise<IConfigCardV2CollapseExcelExport<any>> {
        type keys = CTableColumns;
        type IDataToExport = Partial<Record<keys, string>>;

        const alumno = this.GetCurrentStudent();

        return <IConfigCardCollapseExcelExport<IDataToExport>>{
            FileName: alumno.NombreCompleto + " - " + UIUtilViewData._GetStr_Modulo(this.modulo),
            IdsEscuelas: [alumno.IdKinder],
            TypeRequest: Entidad.CTipoRequest.Alumno,
            ColumnsConfig: [
                { Field: "Periodo", HeaderTag: this.CARDCOLL_GetUIStringModule("d_field_periodo") },
                { Field: "Cargo", HeaderTag: this.CARDCOLL_GetUIStringModule("d_field_descripcion") }, // Descripción
                { Field: "Valor", HeaderTag: this.CARDCOLL_GetUIStringModule("d_field_valor") },
                { Field: "Recargo", HeaderTag: this.CARDCOLL_GetUIStringModule("d_field_recargo") },
                { Field: "PagoAbono", HeaderTag: this.CARDCOLL_GetUIStringModule("d_field_pagoabono") },
                { Field: "Saldo", HeaderTag: this.CARDCOLL_GetUIStringModule("d_field_saldo") },
                { Field: "FechaVencimiento", HeaderTag: this.CARDCOLL_GetUIStringModule("d_field_fechavencimiento"), TypeData: "text" },
                { Field: "FechaPago", HeaderTag: this.CARDCOLL_GetUIStringModule("d_field_fechapago"), TypeData: "text" },
                { Field: "MetodoPago", HeaderTag: this.CARDCOLL_GetUIStringModule("d_field_metodopago") },
            ],
            OnGetDataBySheets: async () => {
                let datosExport: IDataToExport[] = [];

                dataTable.forEach(movimiento => {
                    datosExport.push({
                        Periodo: movimiento.Periodo,
                        Cargo: movimiento.Cargo,
                        ...(() => { // Campos dinámicos
                            const proccessFields: (keyof AlumnoEdoCtaUtil.IMovimientoTbl)[] = ["Valor", "Saldo", "FechaVencimiento"];
                            const result: Partial<IDataToExport> = proccessFields.reduce((res, field) => {
                                res[field] = AlumnoEdoCtaUtil.GetUIStrFieldData("cargo", field, movimiento);
                                return res;
                            }, <Partial<IDataToExport>>{});
                            return result;
                        })()
                    })

                    movimiento.Detalles
                        .forEach((datoChildMov) => {
                            const proccessFields: (keyof AlumnoEdoCtaUtil.IMovimientoTbl)[] = ["Cargo", "Valor", "Recargo", "PagoAbono", "Saldo", "FechaPago", "MetodoPago"];
                            const result: Partial<IDataToExport> = proccessFields.reduce((res, field) => {
                                res[field] = AlumnoEdoCtaUtil.GetUIStrFieldData("detalle", field, datoChildMov);
                                return res;
                            }, <Partial<IDataToExport>>{});
                            datosExport.push(result);
                        })
                });

                return [{
                    IdSheet: alumno.IdKinder, // IdEscuela
                    SheetName: alumno.NombreCompleto,
                    Data: datosExport,
                }]
            },
            OnGetEscuelasTagInSheet: (datos) => _DICC_ESCUELA.get(alumno.IdKinder).Nombre,
        }
    }
    protected CARDCOLLADTAB_Table_GetConfig(): Omit<Table.IConfig<IMovimiento>, "Parent"> {
        const fnAcciones = (movimientos: IMovimiento[]) => {
            const opciones: Table.ITableMenuDataSelectedOptionConfig<IMovimiento>[] = [];

            // EvalGenerarCFDIAction(opciones, this.GetEscuela(), this.cardData[0].IdChild, movimientos)

            if (this.HasActionPermission(Entidad.CAccionPermiso.AgregarDescuentos)) {
                opciones.push({
                    Label: this.CARDCOLL_GetUIStringModule("action_adddesc"),
                    Callback: (datosAsig) => this.OpenModal_AsignarDescuento(datosAsig),
                    GetDetails: () => {
                        let message = '';
                        const enable = !movimientos.some(mov => {
                            if (AlumnoEdoCtaUtil.GetSaldoMovimiento(mov) <= 0) {
                                message = this.CARDCOLL_GetUIStringModule("tlt_adddesc_fail_zero");
                                return true;
                            }
                            const tienePagos = mov.Detalles.some(d => [CCategoriaMov.PagoParcial, CCategoriaMov.PagoCompleto].includes(d.Categoria));
                            if (tienePagos) {
                                message = this.CARDCOLL_GetUIStringModule("tlt_adddesc_fail_withpays");
                            }
                            return tienePagos;
                        });
                        return {
                            Enabled: enable,
                            Description: message
                        };
                    }
                });
            }
            if (this.HasActionPermission(Entidad.CAccionPermiso.Eliminar)) { // NOTE Antes Eliminar solo disponible para Admins ahora con permiso
                opciones.push({
                    Label: this.CARDCOLL_GetUIStringModule("action_eliminar"),
                    Callback: (datoAsig) => this.OpenModal_EliminarRegistro(datoAsig),
                    GetDetails: () => {
                        let message = "";
                        let enable = true;
                        for (const mov of movimientos) {
                            for (const movDetalle of mov.Detalles) {
                                // Valida si tiene pago no consolidado
                                if (AlumnoEdoCtaUtil._IsPagoOnlinePendiente(movDetalle)) {
                                    message = _L("panelfinanzasedocuenta.tlt_dltcargo_fail_no_consolidado");
                                    enable = false;
                                    break;
                                }
                                // Valida si tiene pago parcial
                                const tienePagoParcial = [CCategoriaMov.PagoParcial].includes(movDetalle.Categoria);
                                if (tienePagoParcial && AlumnoEdoCtaUtil.GetSaldoMovimiento(mov) > 0) {
                                    message = _L("panelfinanzasedocuenta.tlt_dltcargo_fail_parcials");
                                    enable = false;
                                    break;
                                }
                            }
                        }
                        return {
                            Enabled: enable,
                            Description: message
                        }
                    }
                })
            }
            return opciones;
        }
        return {
            IdTabla: "AlumnosPanelEstadoCuenta",
            Title: null,
            IdData: "Id",
            OnValueSelectRow: (idDatum, datum, isSelected) => {
                console.log(idDatum, isSelected, datum);
            },
            MinWidth: 1350,
            StickyCheckInRow: true,
            Reorderable: false,
            RenderColumnHeadings: [// FIXMEE
                { Field: CTableColumns.Periodo, Label: "Período", Width: "10%", MinWidth: "90px" },
                { Field: CTableColumns.Descripcion, Label: "Descripción", LabelLangKey: "d_field_descripcion", Width: "15%", MinWidth: "120px" },
                { Field: CTableColumns.Valor, Label: "Adeudo", Width: "8%", MinWidth: "90px" },
                { Field: CTableColumns.Recargo, Label: "Recargos", Width: "8%", MinWidth: "80px" },
                { Field: CTableColumns.PagoAbono as any, Label: "Pagos/abonos", Width: "8%", MinWidth: "120px" }, // Level x (Multiline)
                { Field: CTableColumns.Saldo, Label: "Saldo", Width: "8%", MinWidth: "65px" }, // NOTE En las filas padres, solo mostrar "Saldo" cuando el item no tiene "Detalles".lenght > 0
                { Field: CTableColumns.FechaVencimiento, Label: "Fecha vencimiento", Width: "10%", MinWidth: "100px" },
                { Field: CTableColumns.FechaPago, Label: "Fecha pago", Width: "10%", MinWidth: "100px" }, // Level x (Multiline)
                { Field: CTableColumns.MetodoPago, Label: "Método pago", Width: "8%", MinWidth: "80px" }, // Level x (Multiline)
            ],
            AddNameFieldClassToCells: true,
            OptionsOfActiveSelectedDataV3: (movimientos) => {
                const opciones = fnAcciones(movimientos);
                return this.CARDCOLLADTAB_GetTableOptionsToSelectedData(this.GetIdEscuela(), "top-selected", opciones);
            },
            FilterByStrSearch: datum => columnsTable
                .reduce((result, field) => {
                    result.push(AlumnoEdoCtaUtil.GetUIStrFieldData("cargo", field, datum))
                    const idEscuela = this.GetIdEscuela();
                    if (datum.IdAgrupador > 0) {
                        const agrupador = _DICC_AGRUPADORES_FULL.get(idEscuela)?.get(datum.IdAgrupador);
                        if (agrupador) {
                            result.push(agrupador.Prefix);
                        }
                    }
                    datum.Detalles.forEach(det => {
                        result.push(AlumnoEdoCtaUtil.GetUIStrFieldData("detalle", field, det))
                    })
                    return result
                }, <string[]>[])
                .filter(str => !!str),
            EvaluatorAndSubLevelsBuild: {
                // >> Nivel 1: Movimiento - Cargo

                // GetOptionsInRow: () => this.CARDCOLLAD_GetTableOptionsToSelectedData(this.dataChild.IdKinder, "row"),
                OnStepCellTable: (container, datum, field: keyof IMovimiento) => {
                    container.text(AlumnoEdoCtaUtil.GetUIStrFieldData("cargo", field, datum));

                    switch (field) {
                        case CTableColumns.Descripcion:
                            const idEscuela = this.GetIdEscuela();
                            if (datum.IdAgrupador > 0 && _DICC_AGRUPADORES_FULL.get(idEscuela)?.has(datum.IdAgrupador)) {
                                const tag = UIUtilViewFinanzasIngresoUtil._CreaAgrupadorCargosTag(idEscuela, datum.IdAgrupador);
                                container.append(() => tag._ControlContainer);
                            }

                            container.classed("link_item", true).node()
                                .onclick = e => (e.stopPropagation(), AlumnoEdoCtaMovDetalleCargoModal(this.GetIdEscuela(), datum));
                            break;
                        case CTableColumns.Saldo:
                        case CTableColumns.Valor:
                            this.VerifyAndApplyNegativeColor(datum[field], container);
                            break;
                    }
                },
                GetOptionsInRowV2: (datoAsig) => ({
                    MaxOptionsInRow: 2,
                    Options: fnAcciones([datoAsig])
                }),
                AddRowMultiline: this.GetTableConfigMiltiline()
            }
        }
    }
    protected CARDCOLL_OnInitBuild(container: TSelectionHTML<"div", any, any>): void {
        this.btnEditarCard._d3Selection.remove();
        this.btnCancelarCard._d3Selection.remove();

        container
            .classed(UIUtilGeneral.FBoxOrientation.Vertical, true)
            .classed("finanzas_edocuenta", true)

        let areaMenu = container.append("div")
            .classed(UIUtilGeneral.FBoxOrientation.Horizontal, true)
            .classed(UIUtilGeneral.FBoxAlign.StartCenter, true)
            .classed("area_menu", true);

        let areaInfo = container.append("div")
            .classed(UIUtilGeneral.FBoxOrientation.Horizontal, true)
            .classed(UIUtilGeneral.FBoxAlign.SpacebetweenStart, true)
            .classed("area_info", true)

        areaInfo.append<HTMLImage2Component>("wc-img")
            .attr("class", "escuela_logo")
            .attr("spinner-border-width", 5)
            .attr("spinner-dim", 40);

        areaInfo.append("div")
            .classed(UIUtilGeneral.FBoxOrientation.Vertical, true)
            .classed(UIUtilGeneral.FBoxAlign.StartStart, true)
            .classed("subareainfo_left", true)

        areaInfo.append("div")
            .classed(UIUtilGeneral.FBoxOrientation.Vertical, true)
            .classed(UIUtilGeneral.FBoxAlign.StartStart, true)
            .classed("subareainfo_right", true)

        container.selectAll(".tabla_container").remove();

        this.CARDCOLLADTAB_CreateTable(container);

        // >> Filtros superiores (Ciclo escolar, Periodo)

        this.ctrlSelectCicloEscolar = new SelectV2<ICicloEscolar, "Id">({
            Type: "monoselect",
            Parent: areaMenu,
            Data: () => this.GetCiclosEscolaresList(true),
            ValueMember: "Id",
            DisplayMember: "Nombre",
            ListWidth: "260px",
            OnStepItemListUI: (itemWrapper, d) => render(UIUtilViewCicloEscolar._RenderCicloEscolarBasicItemUI(d), itemWrapper.node()),
            OnChange: (id, cicloEscolar) => {
                console.log(cicloEscolar, "onselect CICLO ESCOLAR")
                let periodos = this.GetPeriodosListFromCicloEscolar(cicloEscolar);
                if (periodos.length) {
                    let periodoValid = periodos.find(d => d.Month == new Date().getMonth() && d.Year == new Date().getFullYear());
                    periodoValid = periodoValid ? periodoValid : periodos[0];
                    this.ctrlSelectPeriodo._UpdateList(periodos)
                    this.ctrlSelectPeriodo._valueSelect(periodoValid.Id);
                }

                const info = this.GetCurrentInfoGeneral();
                this.UI_UpdateCardInfoStatus(info);
                this.ctrlTabla._UpdateData(info.MovimientosTbl_TopPeriodo);
            }
        });
        areaMenu.append(() => ElementWrapper._WrapperToSelectControl(this.ctrlSelectCicloEscolar, this.CARDCOLL_GetUIStringModule("filtro_cicloesc")).node());

        this.ctrlSelectPeriodo = new SelectV2<IPeriodoD, "Id">({
            Type: "monoselect",
            Parent: areaMenu,
            Data: () => this.GetPeriodosListFromCicloEscolar(this.ctrlSelectCicloEscolar._dataSelected[0], this.ctrlSelectCicloEscolar._dataitems),
            ValueMember: "Id",
            DisplayMember: "Name",
            ListWidth: "250px",
            OnStepItemListUI: (container, d) => container
                .style("flex-direction", "column")
                .style("align-items", "start")
                .html(d.Name + (d.EnCicloEscolar ? "" : `<span>${this.CARDCOLL_GetUIStringModule("fueradeciclo")}</span>`))
                .select("span")
                .style("font-size", "var(--fontsize_me4)")
                .style("color", "var(--color_app_red1)"),
            OnChange: (id, periodo) => {
                // console.log(periodo, "onselect PERIODO")
                const info = this.GetCurrentInfoGeneral();
                this.UI_UpdateCardInfoStatus(info);
                this.ctrlTabla._UpdateData(info.MovimientosTbl_TopPeriodo);
            }
        })
        areaMenu.append(() => ElementWrapper._WrapperToSelectControl(this.ctrlSelectPeriodo, this.CARDCOLL_GetUIStringModule("filtro_periodo")).node())
            .style("height", "100%");

        this.ctrlMenuInRowAux = new MenuFlex({
            BtnCloseVisible: false,
            Orientation: "righttoleft",
        });
    }
    protected CARDCOLL_GetVariantToValidateUpdate(cardData_0: IAlumno): string {
        return cardData_0.IdChild.toString();
    }
    protected CARDCOLL_OnUpdateData(cardData_0: IAlumno): any | Promise<any> {
        this.UI_UpdateCardPermissions();
        return this.UI_UpdateCardData(true, true);
    }
    protected CARDCOLL_MostrarBody(): void {
        this.cardSelection.style("height", "100%");
        this.UI_UpdateCardPermissions();
        this.UI_UpdateCardData(false, true);
    }
    protected CARDCOLL_OcultarBody(): void {
        this.cardSelection.style("height", null);
    }
    protected CARDCOLL_OnEditarCard(originEvent: TCARDV2COLL_OnEditOriginEvent): void {
        //throw new Error("Method not implemented.");
    }
    protected CARDCOLL_OnCancelaEditarCard(originEvent: TCARDV2COLL_OnEditOriginEvent): void {
        //throw new Error("Method not implemented.");
    }
    protected CARDCOLL_GuardarCardV2(): Promise<DataDRequest.IRequestResponseA<any>> {
        throw new Error("Method not implemented.");
    }
    protected CARDCOLL_SyncOrGetIdToDownloadData(): DataModuloMain.TipoRequestMonitorId | DataModuloMain.TipoRequestMonitorId[] | (() => any | Promise<any>) {
        return () => this.UI_UpdateCardData();
    }
    protected CARDCOLL_GetIdSchool(cardData_0_0: IAlumno): number {
        return cardData_0_0.IdKinder;
    }

    /* public met_Destroy(): this {
        super.met_Destroy();
        MainPage.fn_RemoveEventListenerWorkerRequest(Entidad.CTipoRequest.Alumno, this["__workerListenerReqAlumno"]);
        this["__workerListenerReqAlumno"] = null;
        return this;
    } */

    private UI_UpdateCardInfoStatus(info: AlumnoEdoCtaUtil.ICurrentData = this.GetCurrentInfoGeneral()) {
        const infoLeft = this.cardContentContainerSelection.select(".subareainfo_left");
        const infoRight = this.cardContentContainerSelection.select(".subareainfo_right");

        let strTutores = (info.Tutoes.length == 0) ? UIUtilLang._GetUIString("general", "sinasignaciones") : info.Tutoes.join(", ");

        infoLeft.html(`
                    <label>${this.CARDCOLL_GetUIStringModule("infoalumno_nombre")}:
                        <span>${info.AlumnoNombre}</span>
                    </label>
                    <!--
                    <label>${this.CARDCOLL_GetUIStringModule("infoalumno_nocta")}:
                        <span>${info.NoCuenta}</span>
                    </label>
                    -->
                    <label>${this.CARDCOLL_GetUIStringModule("infoalumno_tutoresnombrea")}:
                        <span>${strTutores}</span>
                    </label>
                    <label>${this.CARDCOLL_GetUIStringModule("infoalumno_nivel")}:
                        <span>${info.StrNivel}</span>
                    </label>
                `)

        infoRight.html(`
                    <label>${this.CARDCOLL_GetUIStringModule("infocta_fecha")}:
                        <span>${UIUtilTime._DateFormatStandar(new Date())}</span>
                    </label>
                    <label>${this.CARDCOLL_GetUIStringModule("infocta_periodo")}:
                        <span>${info.StrPeriodo || "---"}</span>
                    </label>
                    <label>${this.CARDCOLL_GetUIStringModule("infocta_saldoperiodo")}:
                        <span>${UIUtilFormat._CurrencyFmt(info.SaldoPeriodo)}</span>
                    </label>
                    <label>${this.CARDCOLL_GetUIStringModule("infocta_saldopendiente")}:
                        <span>${UIUtilFormat._CurrencyFmt(info.SaldoPendiente)}</span>
                    </label>
                    <label>${this.CARDCOLL_GetUIStringModule("infocta_totinteres")}:
                        <span>${UIUtilFormat._CurrencyFmt(info.InteresesGenerados)}</span>
                    </label>
                    <label>${this.CARDCOLL_GetUIStringModule("infocta_totpagar")}:
                        <span class="sometotal">${UIUtilFormat._CurrencyFmt(info.TotalPago)}</span>
                    </label>
                `)

        Button._EnableButton(this.btnGuardarCard._d3Selection, (info.TotalPago > 0));
    }

    /** Parte de la configuración de la tabla: Filas hijas de la principal, visualización de los detalles de un cargo */
    private GetTableConfigMiltiline(): Table.IRowMultilineConfig<IMovimiento, IMovimientoDetalle> {
        return {
            OnGetDataToAddRow: (movimiento) => {
                return movimiento.Detalles
            },
            OnStepCell: (content, movDetalle: IMovimientoDetalle, field: keyof IMovimiento, datoAsig) => {
                content
                    .text(AlumnoEdoCtaUtil.GetUIStrFieldData("detalle", field, movDetalle));

                switch (field) {
                    // case CTableColumns.Periodo:
                    //     break;
                    case CTableColumns.Descripcion:
                        AlumnoEdoCtaUtil.GetUIStrFieldDataDescripcion("detalle", movDetalle)
                            .buildHtml(this.GetCurrentStudent(), content, this.ctrlTabla);
                        break;
                    case CTableColumns.Valor:
                        if (movDetalle.Categoria == CCategoriaMov.Descuento) {
                            this.VerifyAndApplyNegativeColor(-movDetalle.Valor, content);
                        }
                        break;
                    // case CTableColumns.Recargo:
                    //     break;
                    case CTableColumns.PagoAbono:
                        if ((movDetalle.Categoria == CCategoriaMov.PagoCompleto) || (movDetalle.Categoria == CCategoriaMov.PagoParcial)) {
                            this.VerifyAndApplyNegativeColor(-movDetalle.Valor, content);
                        }
                        break;
                    case CTableColumns.Saldo:
                        this.VerifyAndApplyNegativeColor(movDetalle.Saldo, content);
                        break;
                    // case CTableColumns.FechaPago:
                    //     break;
                    // case CTableColumns.MetodoPago:
                    //     break;
                }
            },
            OnStepNewTrs: (datum, tr, parentData) => {
                // const invalidMovToDesc = datum.ParentMovimiento.Detalles
                //     .find(d => (d.Categoria == CCategoriaMov.PagoParcial) || (d.Categoria == CCategoriaMov.PagoCompleto));
                const ctrlMenuAux = this.ctrlMenuInRowAux;
                const actionAvailable = [
                    CCategoriaMov.Descuento,
                    CCategoriaMov.Morosidad,
                    CCategoriaMov.PagoCompleto,
                ].includes(datum.Categoria);

                if (ctrlMenuAux._Visible) {
                    ctrlMenuAux._Hide();
                }

                tr.classed("row_shadow_inset", actionAvailable);
                tr.classed("row_pago_enproceso", AlumnoEdoCtaUtil._IsPagoOnlinePendiente(datum));

                if (!actionAvailable) {
                    tr.node().onclick = (e) => {
                        e.stopPropagation();
                        console.debug(datum);
                    }
                } else {
                    tr.node().onclick = (e) => {
                        e.stopPropagation();
                        console.debug(datum);
                        this.ctrlTabla._MenuInRow._Hide();

                        const visible = ctrlMenuAux._Visible;
                        const idRef = ctrlMenuAux["__IdRef"];
                        const fnMenuAuxHideAndClear = () => {
                            ctrlMenuAux._Hide();
                            ctrlMenuAux._UpdateMenuOptions([]); // ? null
                        }

                        if (visible && idRef == datum.Id) {
                            fnMenuAuxHideAndClear()
                        } else {
                            let opt: MenuFlex.IMenuItemConfig[] = [];
                            if (datum.Categoria == CCategoriaMov.Descuento && this.HasActionPermission(Entidad.CAccionPermiso.EliminarDescuentos)) {
                                const esSaldado = datum.ParentMovimiento.Detalles.some(d => [CCategoriaMov.PagoCompleto].includes(d.Categoria))
                                opt.push({
                                    Label: this.CARDCOLL_GetUIStringModule("action_eliminar_desc"),
                                    OnClick: async () => {
                                        fnMenuAuxHideAndClear()
                                        console.log("Descuento ", datum);
                                        this.OpenModal_EliminarDescuento(datum);
                                    },
                                    Enabled: !esSaldado,
                                    Description: esSaldado ? _L("panelfinanzasedocuenta.tag_saldado") : ""
                                })
                            }
                            if (datum.Categoria == CCategoriaMov.Morosidad && this.HasActionPermission(Entidad.CAccionPermiso.Eliminar)) {
                                // NOTE: Eliminar morosidad si es último movimiento
                                if (datum.ParentMovimiento.Detalles[datum.ParentMovimiento.Detalles.length - 1] === datum) {
                                    opt.push({
                                        Label: this.CARDCOLL_GetUIStringModule("action_eliminar_moro"),
                                        OnClick: () => {
                                            fnMenuAuxHideAndClear()
                                            console.log("Morosidad ", datum);
                                            this.OpenModal_EliminarMorosidad(datum);
                                        },
                                    })
                                }
                            }
                            // if (DataUtil._Usuario._PerfilAdmin && datum.Categoria == CCategoriaMov.PagoCompleto) { // && this.HasActionPermission(Entidad.CAccionPermiso.Eliminar)) {
                            if (DataUtil._Usuario._PerfilAdmin && datum.Categoria == CCategoriaMov.PagoCompleto && !AlumnoEdoCtaUtil._IsPagoOnlinePendiente(datum)) {
                                const esPagoOpay = datum.IdMetodoPago == AlumnoEdoCtaUtil.ID_METODOPAGO_ENLINEA_TEMP
                                    || DataModuloMain._GetDataValueFieldByName("FinanzaMetodoPago", datum.IdMetodoPago, "ProveedorElectronico") == 1
                                const esFacturado = datum.IdFacturaFolio > 0
                                opt.push({
                                    Label: _L("panelfinanzasedocuenta.action_eliminar_pago_7"),
                                    OnClick: () => {
                                        fnMenuAuxHideAndClear()
                                        console.log("Pago ", datum);
                                        this.OpenModal_EliminarPago(datum);
                                    },
                                    Enabled: !esPagoOpay && !esFacturado,
                                    Description: esFacturado ? _L("panelfinanzasedocuenta.no_eliminar_pago_factura") : esPagoOpay ? _L("panelfinanzasedocuenta.no_eliminar_pago_opay") : null,
                                })
                            }
                            if (opt.length > 0) {
                                this.ctrlTabla._MenuInRow
                                    ._OnShow(() => {
                                        fnMenuAuxHideAndClear()
                                    })
                                ctrlMenuAux["__IdRef"] = datum.Id;
                                ctrlMenuAux._SetParent(tr.select(".lastcell"));
                                const DivSpaceTable = this.ctrlTabla._Control.select(".area_control").select<HTMLDivElement>(".space_tabla");
                                ctrlMenuAux._SetOnGetMaxWidthCallback(() => TableUtil._GetMaxWidthMenuFlex(tr, 0, DivSpaceTable, ctrlMenuAux))
                                ctrlMenuAux._SetResizeReferenceSelection(DivSpaceTable);
                                ctrlMenuAux._UpdateMenuOptions(opt)
                                ctrlMenuAux._Show();
                            }
                        }
                    }
                }
                return true;
            }
        }
    }

    private VerifyAndApplyNegativeColor(valor: number, element?: Selection<HTMLElement, any, any, any>): string {
        let color = (valor < 0) ? "red" : null;
        element?.style("color", color);
        return color;
    }

    // ************************************************************************
    // DETALLES
    // ************************************************************************
    //#region Detalles de movimientos



    //#endregion

    // ************************************************************************
    // PROCESO: REGISTRO DE DESCUENTO
    // ************************************************************************
    //#region Descuento

    private OpenModal_AsignarDescuento(datosMovts: IMovimiento[]) {
        type TFormData = {
            IdDescuento: number;
            Descuento: IFinanzaCargo;
        };

        const datosMovsProcesar = datosMovts.filter(d => (AlumnoEdoCtaUtil.GetSaldoMovimiento(d) > 0));
        const datosMovsEnCero = datosMovts.filter(d => (AlumnoEdoCtaUtil.GetSaldoMovimiento(d) == 0));

        if (datosMovsProcesar.length == 0) {
            this.ctrlNotification._Mostrar("Error", "ADVERTENCIA");
            return;
        }

        const descuentosDisponiblesList = this.GetDescuentosList();
        const descuentosInvalidosList = descuentosDisponiblesList
            .filter(d => {
                return datosMovsProcesar
                    .every(cargoMov => (!UIUtilViewFinanzaCargo._DATA_ValidaDescuentosACargo(AlumnoEdoCtaUtil.GetSaldoMovimiento(cargoMov), [d]).Valido))
            })
            .map(d => d.ID);

        if (descuentosDisponiblesList.length == 0) {
            this.ctrlNotification._Mostrar(_L("panelfinanzasedocuenta.notif_nodescuentosregistds", this.GetEscuela().Nombre), "ADVERTENCIA");
            return;
        }

        let form: FormGenerator<TFormData>;

        ModalThings._GetModalToALongProccess({
            Modulo: this.modulo,
            IdsEscuelas: [this.GetIdEscuela()],
            LangModuleKeyInContext: this.moduloName,
            StartEndIds: ["form", "info"],
            StepsConfig: [
                {
                    Id: "form",
                    Title: "action_adddesc",
                    NextID: "info",
                    Width: 400,
                    OnDrawContent: (content, mt) => {
                        form = new FormGenerator<TFormData>()
                            ._Crear({
                                LabelMaxWidth: 150,
                                LangModuleKeyInContext: this.moduloName,
                                schema: [
                                    {
                                        model: "IdDescuento",
                                        type: Fields.selectMaterial, labelAttr: { text: "frm_eligedescuento" },
                                        selectMaterialAttr: {
                                            valueMember: "ID",
                                            displayMember: "Nombre",
                                            ShowAndEnableSearchText: true,
                                            required: true,
                                            onChange: (idDescuento: number, descuentoInfo: IFinanzaCargo) => {
                                                form._DataOrigin.Descuento = descuentoInfo;
                                            },
                                            OnStepItemListUI: (container, datoDesc: IFinanzaCargo) => {
                                                const valid = datosMovsProcesar
                                                    .every(cargoM => {
                                                        return UIUtilViewFinanzaCargo._DATA_ValidaDescuentosACargo(AlumnoEdoCtaUtil.GetSaldoMovimiento(cargoM), [datoDesc]).Valido;
                                                    })

                                                container
                                                    .classed(UIUtilGeneral.FBoxOrientation.Vertical, true)
                                                    .style("align-items", "start")
                                                    .text(datoDesc.Nombre);

                                                if (valid) {
                                                    container.select(".lbl_invalid")
                                                        .remove();
                                                } else {
                                                    container.append("label")
                                                        .attr("class", "lbl_invalid")
                                                        .style("color", "red")
                                                        .style("font-size", "var(--fontsize_me4)")
                                                        .text(this.CARDCOLL_GetUIStringModule("tag_excedesaldo"));
                                                }
                                            }
                                        },
                                        values: descuentosDisponiblesList
                                    },
                                ],
                                Validation: (value, field, dataForm) => {
                                    //if (value != null) {
                                    const descuentoSelected = form._DataOrigin.Descuento; // descuentosDisponiblesList.find(d => (d.ID == value as number));

                                    if (descuentoSelected) {
                                        return datosMovsProcesar
                                            .every(cargoM => {
                                                return UIUtilViewFinanzaCargo._UI_ValidaDescuentosACargo(AlumnoEdoCtaUtil.GetSaldoMovimiento(cargoM), cargoM.Cargo, [descuentoSelected]);
                                            });
                                    } else {
                                        return false;
                                    }
                                    //}
                                    //return false;
                                }
                            }, <TFormData>{});

                        (form._ControlsData.get("IdDescuento").instance as SelectV2<IFinanzaCargo, "ID">)
                            ._disableItems(descuentosInvalidosList);

                        content.append(() => form._Form.node());
                    },
                    OnValideStep: (content, mt) => form._GetIsValidForm()
                },
                {
                    Id: "info",
                    Title: "action_adddesc",
                    PreviousID: "form",
                    Width: 320,
                    OnDrawContent: (content, mt) => {
                        content
                            .classed(UIUtilGeneral.FBoxOrientation.Vertical, true)
                            .style("row-gap", "10px");

                        content.append("label")
                            .text(this.CARDCOLL_GetUIStringModule("tag_movsprocesar") + ":");

                        content.append("div")
                            .attr("class", "items " + UIUtilGeneral.FBoxOrientation.Vertical)
                            .style("row-gap", "10px")
                            .style("overflow", "hidden auto")
                            .style("max-height", "400px");
                    },
                    OnFocusContent: (container, mt) => {
                        const fnUpdateItemCargo = (item: TSelectionHTML<"div", IMovimiento>) => {
                            return item
                                .each((d, i, arr) => {
                                    const esValidoParaDesc = (AlumnoEdoCtaUtil.GetSaldoMovimiento(d) > 0);
                                    let container = select(arr[i]);

                                    if (!container.select("label").node()) {
                                        // Nombre periodo
                                        container.append("label")
                                            .text(this.CARDCOLL_GetUIStringModule("tag_period") + ": ")
                                            .append("span");
                                        // Descripción cargo
                                        container.append("label")
                                            .text(this.CARDCOLL_GetUIStringModule("tag_descript") + ": ")
                                            .append("span")
                                            .style("cursor", "help");
                                        // Saldo
                                        container.append("label")
                                            .text(this.CARDCOLL_GetUIStringModule("d_field_saldo") + ": ")
                                            .append("span");
                                        // Descuento
                                        container.append("label")
                                            .text(this.CARDCOLL_GetUIStringModule("tag_desc") + ": ")
                                            .append("span")
                                            .style("color", "red");
                                    }
                                    // Tag periodo
                                    container.select("label:nth-child(1) > span")
                                        .text(d.Periodo);

                                    // Tag descripción cargo
                                    let lblCargoNombre = container.select("label:nth-child(2) > span")
                                        .style("color", (!esValidoParaDesc ? "red" : null))
                                        .text(d.Cargo);

                                    if (!esValidoParaDesc) {
                                        if (!lblCargoNombre.select("img").node()) {
                                            lblCargoNombre.append("img")
                                                .attr("src", UIUtilIconResources.CGeneral.InfoMark)
                                                .attr("draggable", false)
                                                .style("margin-left", "5px")
                                                .style("width", "14px");

                                            lblCargoNombre.append("wc-tooltip")
                                                .attr("max-width", "150px")
                                                .attr("position", "right");
                                        }

                                        lblCargoNombre.select("wc-tooltip")
                                            .html(`<span style="color:red;">${this.CARDCOLL_GetUIStringModule("tag_noaplica")}.</span> <br>${this.CARDCOLL_GetUIStringModule("tag_cargocero")}`);
                                    }
                                    else {
                                        lblCargoNombre.select("img").remove();
                                        lblCargoNombre.select("wc-tooltip").remove();
                                    }

                                    // Tag Saldo
                                    container.select("label:nth-child(3) > span")
                                        .text(UIUtilFormat._CurrencyFmt(AlumnoEdoCtaUtil.GetSaldoMovimiento(d)));

                                    // Tag Descuento
                                    let tagDescuento = "";

                                    if (esValidoParaDesc) {
                                        let descuentoSelected = form._DataOrigin.Descuento;
                                        let descuentoValor = UIUtilViewFinanzaCargo._DATA_ValidaDescuentosACargo(AlumnoEdoCtaUtil.GetSaldoMovimiento(d), [descuentoSelected]).DescuentoMontoTotal;
                                        tagDescuento = "-" + UIUtilFormat._CurrencyFmt(descuentoValor);

                                        if (descuentoSelected.TipoValor == CTipoValor.Porcentaje) {
                                            tagDescuento += ` (${UIUtilFormat._PercentFmt(descuentoSelected.Valor)})`;
                                        }
                                    }

                                    container.select("label:nth-child(4)")
                                        .classed("hide", !esValidoParaDesc)
                                        .select("span")
                                        .text(tagDescuento);
                                });
                        }

                        container.select(".items")
                            .selectAll<HTMLDivElement, IMovimiento>(".itemcargo")
                            .data([...datosMovsProcesar, ...datosMovsEnCero])
                            .join(
                                enter => fnUpdateItemCargo(
                                    enter.append("div")
                                        .attr("class", "itemcargo")
                                        .classed(UIUtilGeneral.FBoxOrientation.Vertical, true)
                                ),
                                update => fnUpdateItemCargo(update),
                                exit => exit.remove()
                            )
                    },
                    OnAccept: async (mt) => {
                        const res = await _SvAlumnoEdoCtaNuevosDescuentos(datosMovsProcesar.map(d => d.Id), this.cardData[0].IdChild, form._Data.IdDescuento);
                        if (res.Resultado > 0 || [-1, -2].includes(res.Resultado)) {
                            this.UI_UpdateCardData();
                        }
                        return res;
                    }
                }
            ]
        });
    }

    //#endregion

    // ************************************************************************
    // PROCESO: ELIMINAR REGISTRO: CARGO, DESCUENTO, MOROSIDAD, PAGO
    // ************************************************************************
    //#region Eliminar registros

    private OpenModal_EliminarRegistro(datoAsig: IMovimiento[]) {
        const { IdChild, IdKinder } = this.cardData[0] || {};
        let forceUpdate = false;
        this.CARDCOLLAD_OpenModal_ProccessArrayData({
            DataToProccess: datoAsig,
            Width: 400,
            Message: this.CARDCOLL_GetUIStringModule("confirma_eliminar"),
            OnGetIdEscuela: (dato) => IdKinder,
            OnError_GetItemDataTag: (dato) => {
                let tag = `${this.CARDCOLL_GetUIStringModule("tag_descript")}: <b>${dato.Cargo}</b>`;
                // tag += `<br>Periodo: ${Utils.Time.fn_DateFormatStandar(new Date(dato.FechaInicio))} - ${Utils.Time.fn_DateFormatStandar(new Date(dato.FechaFin))}`;
                tag += `<br>${this.CARDCOLL_GetUIStringModule("tag_period")}: ${dato.Periodo}`;
                return tag + `<br>${this.CARDCOLL_GetUIStringModule("tag_fechaaplica")}: ${UIUtilTime._DateFormatStandarFixTimeZoneByIdSchool(dato.FechaAplicacion, IdKinder)}`;
            },
            OnStepAProccess: async (dato) => {
                const res = await _SvAlumnoEdoCtaEliminarMovimiento(IdChild, dato.Id);
                if (!forceUpdate && res.Resultado == -1) forceUpdate = true;
                return res;
            },
            TypeRequest: null,
            OnEndAndCloseProccess: async (datosCorrectos) => {
                if (datosCorrectos.length || forceUpdate) {
                    this.UI_UpdateCardData();
                }
            }
        })
    }

    private OpenModal_EliminarDescuento(descuento: IMovimientoDetalle) {
        ModalThings._GetModalToAProccess({
            Title: this.CARDCOLL_GetUIStringModule("action_eliminar_desc"),
            Width: 300,
            DrawContent: (container, mt) => {
                container.text(this.CARDCOLL_GetUIStringModule("confirma_eliminar_desc"))
            },
            OnAccept: async (mt) => {
                const res = await _SvAlumnoEdoCtaEliminarDescuento(descuento.Id, descuento.ParentMovimiento.Id);
                const forceCloser = [-1, -2, -4].includes(res.Resultado);

                if (res.Resultado > 0 || forceCloser) {
                    this.UI_UpdateCardData(false, true);

                    if (forceCloser) {
                        mt.Modal._Ocultar();
                    }
                }

                return res;
            }
        });
    }

    private OpenModal_EliminarMorosidad(morosidad: IMovimientoDetalle) {
        ModalThings._GetModalToAProccess({
            Title: this.CARDCOLL_GetUIStringModule("action_eliminar_moro"),
            Width: 300,
            AccionToHttpMessage: "alumno_edocta_eliminar_morosidad",
            DrawContent: (container, mt) => {
                container.text(this.CARDCOLL_GetUIStringModule("confirma_eliminar_moro"));
            },
            OnAccept: async (mt) => {
                let res = await _SvAlumnoEdoCtaEliminarMorosidad(morosidad.Id, morosidad.ParentMovimiento.Id);
                let forceCloser = (res.Resultado == -1);

                if (res.Resultado > 0 || forceCloser) {
                    this.UI_UpdateCardData(false, true);

                    if (forceCloser) {
                        mt.Modal._Ocultar();
                    }
                }
                return res;
            }
        })
    }

    private OpenModal_EliminarPago(pago: IMovimientoDetalle) {
        ModalThings._GetModalToAProccess({
            Title: _L("panelfinanzasedocuenta.action_eliminar_pago_7"),
            Width: 300,
            DrawContent: (container, mt) => {
                container.text(this.CARDCOLL_GetUIStringModule("confirma_eliminar_pago"));
            },
            OnAccept: async (mt) => {
                let res = await _SvAlumnoEdoCtaEliminarPagoCompleto(pago.Id, pago.ParentMovimiento.Id);
                let forceCloser = (res.Resultado == -1);

                if (res.Resultado > 0 || forceCloser) {
                    this.UI_UpdateCardData(false, true);

                    if (forceCloser) {
                        mt.Modal._Ocultar();
                    }
                }
                return res;
            }
        })
    }

    //#endregion

    // **************************************************************************
    // UI UPDATE
    // **************************************************************************
    //#region UI UPDATE

    /**
     * 
     * @param updateLogo @default false
     * @param showProgressBar @default false
     */
    private UI_UpdateCardData(updateLogo: boolean = false, showProgressBar = false) {
        if (this.cardData == undefined) {
            console.log("DataUndefined");
            return null;
        };
        if (updateLogo) {
            this.cardContentContainerSelection.select<HTMLImage2Component>(".escuela_logo")
                .attr("src", this.GetEscuela().Logo);
            // .text(this.GetEscuela().Nombre)
        }
        if (!this.CARDCOLL_StatusCardExpandido) {
            this.ctrlTabla._UpdateData([]);
            return true;
        }

        return new Promise<boolean>(async (resolve, reject) => {
            if (showProgressBar) {
                this.ctrlProgress.attr("oculto", false);
            }

            // >> Get Data

            const result = await this.Sv_GetMovementsList();

            // >> Update UI

            let cicloEscCurrent: ICicloEscolar;
            this.ctrlSelectCicloEscolar._RefreshList();
            const cicloesEscolaresList = this.ctrlSelectCicloEscolar._dataitems;
            if (!this.ctrlSelectCicloEscolar._dataValueMemberSelected.length) {
                cicloEscCurrent = this.GetCurrentCicloEscolar(cicloesEscolaresList);
                this.ctrlSelectCicloEscolar._valueSelect(cicloEscCurrent?.Id);
            }

            this.ctrlSelectPeriodo._RefreshList();
            const periodosList = this.ctrlSelectPeriodo._dataitems;
            if (!this.ctrlSelectPeriodo._dataValueMemberSelected.length) {
                const periodoCurrent = this.GetInitPeriodoFromCicloEsc(cicloEscCurrent, periodosList);
                this.ctrlSelectPeriodo._valueSelect(periodoCurrent?.Id);
            }

            const dataInfo = this.GetCurrentInfoGeneral(true);

            this.UI_UpdateCardInfoStatus(dataInfo);
            this.ctrlTabla._UpdateData(dataInfo.MovimientosTbl_TopPeriodo);

            // this.ctrlTabla.met_UpdateData(this.listaMovimientosFiltrados);// FIXME
            // } else {
            //     // NOTE Se limpia en caso de que falle la consulta con un alumno nuevo,
            //     // no debe conservar los datos del alumno anterior  // TEMPORAL
            //     this.ctrlTabla.met_UpdateData([]);
            // }
            if (showProgressBar) {
                this.ctrlProgress.attr("oculto", true);
            }

            resolve(result);
        })
    }

    //#endregion

    // **************************************************************************
    // PERMISOS
    // **************************************************************************
    //#region PERMISOS

    private UI_UpdateCardPermissions() {
        const hasPermission = this.HasActionPermission(Entidad.CAccionPermiso.RegistrarPagos);
        this.btnGuardarCard._enabled = hasPermission;

        if (this.CARDCOLL_StatusCardExpandido) {
            this.cardFooterSelection.classed("hide", !hasPermission);
        } else {
            this.cardFooterSelection.classed("hide", true);
        }

        if (hasPermission) {
            this.btnGuardarCard._d3Selection
                .text(this.CARDCOLL_GetUIStringModule("pay"))
                .on("click", () => {
                    if (this.btnGuardarCard._d3Selection.attr("oculto") == "true") return;

                    this.btnGuardarCard._d3Selection.attr("oculto", true);

                    _OpenModal_ProcesoPago({
                        Escuela: this.GetEscuela(),
                        PreSeleccionados: this.ctrlTabla._getActiveSelectedData,
                        InfoGeneral: this.GetCurrentInfoGeneral(),
                        OnClose: () => this.btnGuardarCard._d3Selection.attr("oculto", null),
                        OnAccept_SuccessPays: () => this.UI_UpdateCardData(false, true),
                    });
                })
        }
    }

    //#endregion

    // **************************************************************************
    // DATA - LOCAL
    // **************************************************************************
    //#region DATA - LOCAL

    private GetEscuela() {
        return _DICC_ESCUELA.get(this.GetIdEscuela());
    }

    private GetIdEscuela() {
        return this.cardData ? this.cardData[0]?.IdKinder : null;
    }

    private GetCurrentStudent() {
        return this.cardData[0];
    }

    private GetIdCurretStudent() {
        return this.GetCurrentStudent()?.IdChild;
    }

    /**
     * @returns
     * * El ciclo escolar actual (de acuerdo a la fecha actual)
     * * En caso de no existir uno, retorna el primer elemento de la lista
     * */
    private GetCurrentCicloEscolar(ciclosEscolares = this.GetCiclosEscolaresList()): (ICicloEscolar | null) {
        const now = new Date();

        let cicloEsc = ciclosEscolares
            .find(d => new Date(d.FechaInicio) <= now && new Date(d.FechaFin) >= now);

        if (!cicloEsc) {
            cicloEsc = ciclosEscolares[0];
        }

        return cicloEsc;
    }

    /**
     * @returns
     * * El periodo actual (de acuerdo a la fecha actual)
     * * En caso de no existir uno, retorna el primer elemento de la lista
     * */
    private GetInitPeriodoFromCicloEsc(cicloEscolar: ICicloEscolar, periodos = this.GetPeriodosListFromCicloEscolar(cicloEscolar)): (IPeriodoD | null) {
        const now = new Date();
        let periodo = periodos
            .find(d => d.Month == now.getMonth() && d.Year == now.getFullYear());

        if (!periodo && periodos) {
            periodo = periodos[0];
        }

        return periodo;
    }


    /**
     * * Los datos cálculados a partir de los movimientos se hace en base al periodo actual
     * * Filtro de movimientos con la FechaAplicacion
     */
    private GetCurrentInfoGeneral(forceUpdate = false): AlumnoEdoCtaUtil.ICurrentData {
        const student = this.GetCurrentStudent();
        const periodo = this.ctrlSelectPeriodo._dataSelected[0];

        if (!this.infoGeneral) {
            forceUpdate = true;
        }
        else if (this.infoGeneral.IdAlumno != student?.IdChild || this.infoGeneral.StrPeriodo != periodo?.Name) {
            forceUpdate = true;
        }

        if (forceUpdate) {
            //** Todos los movimientos menores o iguales al año y mes del periodo filtrado */
            let movimientosTopPeriodoChidos: IMovimiento[] = [];
            //** Solo los movimientos pertenecientes al periodo actual */
            let movimientosPeriodo: IMovimiento[] = [];
            let saldoPeriodo = 0;
            let saldoPendiente = 0;
            let interesesGenerados = 0;
            let tutores: string[] = [];

            if (student) {
                tutores = Array.from(_LOCALDATA_GetTutoresDeAlumno(student.IdChild).values())
                    .map(d => (`${d.Nombre} ${d.ApPaterno}`));
            }

            if (periodo) {
                const datePeriodoValidator = new Date(periodo.Year, periodo.Month, 1);
                const periodoValidator = GetDateValidatorYM(datePeriodoValidator);

                // Filtra movimientos
                this.GetMovimientosList()
                    .forEach(mov => {
                        const newMov = Object.assign({}, mov);
                        const dateA = new Date(newMov.FechaAplicacion);
                        const dateVValidator = GetDateValidatorYM(dateA);
                        const esPeriodoActual = dateA.getFullYear() == periodo.Year && dateA.getMonth() == periodo.Month;

                        if (dateVValidator <= periodoValidator) {
                            let detallesChidos = [];
                            if (newMov.Detalles) {
                                const tienePagoCompleto = newMov.Detalles.some(d => d.Categoria == CCategoriaMov.PagoCompleto);
                                newMov.Detalles.forEach((detalle: IMovimientoDetalle, i) => {
                                    if (!(detalle.Categoria == CCategoriaMov.Morosidad && detalle.Recargo == 0)) {
                                        detalle.ParentMovimiento = newMov;
                                        detallesChidos.push(detalle);
                                        if (!tienePagoCompleto) {
                                            const detallePosterior = newMov.Detalles[i + 1];
                                            const detallePosteriorCancela = (
                                                detallePosterior
                                                && [CCategoriaMov.PagoCompleto, CCategoriaMov.PagoParcial, CCategoriaMov.Descuento].includes(detallePosterior.Categoria)
                                            );
                                            if (!detallePosteriorCancela) {
                                                interesesGenerados += detalle.Recargo; // ACUMULACIÓN DE RECARGOS
                                            }
                                        }
                                    }
                                })
                            }
                            newMov.Detalles = detallesChidos;
                            movimientosTopPeriodoChidos.push(newMov);

                            let childsSinMorosidad = newMov.Detalles ? newMov.Detalles.filter(d => d.Categoria != CCategoriaMov.Morosidad) : [];

                            if (esPeriodoActual) {
                                // this.infoCurrentData.MovimientosPeriodo.push(newMov);
                                movimientosPeriodo.push(newMov);

                                let auxSaldoPeriodo = newMov.Saldo
                                if (childsSinMorosidad.length > 0) {
                                    auxSaldoPeriodo = childsSinMorosidad[childsSinMorosidad.length - 1].Saldo;
                                }
                                saldoPeriodo += auxSaldoPeriodo; // - totalPago);
                            } else {
                                let auxSaldoPendiente = newMov.Saldo;
                                if (childsSinMorosidad.length > 0) {
                                    auxSaldoPendiente = childsSinMorosidad[childsSinMorosidad.length - 1].Saldo;
                                }
                                saldoPendiente += auxSaldoPendiente; // - totalPago);
                            }
                        }
                    })
            }

            this.infoGeneral = {
                IdAlumno: student?.IdChild,
                AlumnoNombre: (student?.NombreCompleto || ""),
                NoCuenta: (this.infoGeneral?.NoCuenta || _L("general.nodisponible")), // NOTE Corregir cuando tenga no.cta.
                Tutoes: tutores,
                StrNivel: (student?.StrEscolaridad || ""),

                StrPeriodo: (periodo?.Name || ""),
                SaldoPeriodo: saldoPeriodo,
                SaldoPendiente: saldoPendiente,
                InteresesGenerados: interesesGenerados,
                TotalPago: (saldoPeriodo + saldoPendiente + interesesGenerados),
                MovimientosPeriodo: movimientosPeriodo
                    .sort((a, b) => Number(new Date(b.FechaAplicacion)) - Number(new Date(a.FechaAplicacion))),

                MovimientosTbl_TopPeriodo: movimientosTopPeriodoChidos
                    .sort((a, b) => Number(new Date(b.FechaAplicacion)) - Number(new Date(a.FechaAplicacion)))
            }
        }

        return this.infoGeneral;
    }

    private GetStrPeriodo(fechaInicio: string, fechaFin: string): string {
        const startMonthName = UIUtilTime._DateFormatStandar(fechaInicio, "MMM yyyy");
        const endMonthName = UIUtilTime._DateFormatStandar(fechaFin, "MMM yyyy");

        if (!endMonthName || startMonthName == endMonthName) {
            return UIUtilStrings._CapitaliceString(startMonthName);
        }

        return `${UIUtilStrings._CapitaliceString(startMonthName)} - ${UIUtilStrings._CapitaliceString(endMonthName)}`;
    }

    /**
     * @param type @default "all"
     * * Para realizar el filtro, se extrae el periodo seleccionado en el filtro
     */
    private GetMovimientosList(): IMovimiento[] {
        return this.movimientosMap ? (this.movimientosMap.get(this.GetIdCurretStudent()) || []) : [];
    }

    /** Obtiene todos los ciclos escolares donde existen movimientos */
    private GetCiclosEscolaresList(force: boolean = !Boolean(this.ciclosEscolaresList?.length)) {
        if (force) {
            this.ciclosEscolaresList = DataModuloMain._GetReqDataArrayByName("CicloEscolar")
                .filter(dCiclo => {
                    if (dCiclo.IdEscuela == this.GetIdEscuela()) { // && new Date(dCiclo.FechaInicio) < new Date()) {
                        return Boolean(this.GetMovimientosList().find(mov => (mov.CicloEscolar == dCiclo.Id)));
                    }
                    return false;
                })
                .sort((a, b) => Number(new Date(b.FechaInicio)) - Number(new Date(a.FechaInicio)));
        }
        return (this.ciclosEscolaresList || []);
    }

    /** Obtiene todos los meses (dentro del ciclo escolar)  donde existen movimientos */
    private GetPeriodosListFromCicloEscolar(cicloEscolar: ICicloEscolar, ciclosEscolaresList = this.GetCiclosEscolaresList(true)): IPeriodoD[] {
        const ultimoCiclo = ciclosEscolaresList.findIndex(c => c.Id == cicloEscolar.Id) == 0;
        const movimientos = this.GetMovimientosList();
        let periodos: IPeriodoD[] = [];

        if (cicloEscolar && movimientos.length) {
            const maxMovAplicacionDate: IMovimiento = movimientos.reduce((a, b) => (new Date(a.FechaAplicacion) > new Date(b.FechaAplicacion) ? a : b));
            const maxAplicacionDateEval = GetDateValidatorYM(new Date(maxMovAplicacionDate.FechaAplicacion));
            const now = new Date();
            now.setDate(2);

            const getIsValidPeriodoByMovs = (periodoValidator: number) => {
                let itemMenorAPeriodo = movimientos
                    .find(mov => (GetDateValidatorYM(new Date(mov.FechaAplicacion)) <= periodoValidator));

                return (itemMenorAPeriodo && (periodoValidator <= maxAplicacionDateEval));
            }

            periodos = UIUtilViewData._GetPeriodosFromCicloEscolar(cicloEscolar, false)
                .filter(d => {
                    now.setFullYear(d.Year);
                    now.setMonth(d.Month);
                    let procesoPeriodoValidator = GetDateValidatorYM(now);
                    return getIsValidPeriodoByMovs(procesoPeriodoValidator)
                })
                .map(d => ({ ...d, EnCicloEscolar: true }));

            if (ultimoCiclo) {
                const auxPeriodoMap = new Map(periodos.map(d => [GetDateValidatorYM(new Date(d.Year, d.Month, 2)), d]))
                const maxPeriodo = auxPeriodoMap.size ? Array.from(auxPeriodoMap.keys()).reduce((a, b) => a > b ? a : b) : 0;
                periodos = movimientos.reduce((periodos, mov) => {
                    const dt = new Date(mov.FechaAplicacion)
                    const mov_yyyymm = GetDateValidatorYM(dt)
                    if (!auxPeriodoMap.has(mov_yyyymm) && mov_yyyymm > maxPeriodo) {
                        auxPeriodoMap.set(mov_yyyymm, {
                            Id: mov_yyyymm,
                            Month: dt.getMonth(),
                            Year: dt.getFullYear(),
                            Name: UIUtilStrings._CapitaliceString(UIUtilTime._DateFormatStandar(dt, "MMM yyyy")),
                            EnCicloEscolar: false,
                        })
                        periodos.push(auxPeriodoMap.get(mov_yyyymm))
                    }
                    return periodos;
                }, periodos).sort((a, b) => new Date(b.Year, b.Month, 2).getTime() - new Date(a.Year, a.Month, 2).getTime())
            }
        }
        // console.log(periodos, "init edocta periodos");
        return periodos;
    }

    private GetDescuentosList() {
        return Array.from(_DICC_FINANZAS_CARGOS.values())
            .filter(d => d.Categoria == Entidad.CFinanzaCargoCategoria.Descuento && d.IdEscuela == this.GetIdEscuela())
            .map(d => Object.assign({}, d));
    }

    //#endregion

    // **************************************************************************
    // DATA - SERVICIOS
    // **************************************************************************
    //#region DATA - SERVICIOS

    private async Sv_GetMovementsList() {
        const idAlumno = this.GetIdCurretStudent();
        const idEscuela = this.GetIdEscuela();

        await _SvFinanzasObtenerListaAgrupadorCargos(idEscuela, true);
        await _SvAlumnoEdoCtaObtenerFoliosPagoEnLinea(idAlumno, idEscuela);

        const res = await _SvAlumnoEdoCtaObtenerListaMovimientos(idAlumno, idEscuela);
        const movimientosRes: IMovimiento[] = (res.Datos || []);

        if (res.Resultado > 0) {
            // Consultar agrupadores que pudieran estar eliminador
            const idsAgrupadoresEliminador = new Set<number>(
                res.Datos
                    .filter(m => (m.IdAgrupador > 0 && !_DICC_AGRUPADORES_FULL.has(m.IdAgrupador))) // no existe en el diccionario global
                    .map(m => m.IdAgrupador)
            );

            if (idsAgrupadoresEliminador?.size > 0) {
                await _SvFinanzasObtenerListaAgrupadorCargosByIds(idEscuela, Array.from(idsAgrupadoresEliminador.values()));
            }

            // Asignar detalles a movimientos ...
            this.movimientosMap.set(idAlumno, movimientosRes);

            /** Map<idMovimientoPadre, IMovimientoDetalle> */
            const cargosPagosOnlinePendientes = new Map<number, IMovimientoDetalle>(
                Array.from(_DICC_ALUMNO_MOVPAGO_FOLIO.values()).reduce((result, folioPagoObj) => {
                    if (folioPagoObj.EstadoPago != CFinanzaPagoEnLineaEstado.Pendiente) {
                        return result;
                    }
                    folioPagoObj.IdsMovimientos.forEach((idMovPadre, i) => {
                        const movPagoOnlineTemporal: IMovimientoDetalle = AlumnoEdoCtaUtil._CreateMovPagoNoConsolidado(folioPagoObj, i);
                        result.push([idMovPadre, movPagoOnlineTemporal]);
                    });
                    return result;
                }, [] as [number, IMovimientoDetalle][])
            );

            const agrupadorMovsPagosFolioPagoOnline = new Map<string, IMovimientoDetalle[]>();
            movimientosRes
                .forEach(mov => {
                    const movPagoOnlineTemporal = cargosPagosOnlinePendientes.get(mov.Id);
                    if (movPagoOnlineTemporal) {
                        movPagoOnlineTemporal.ParentMovimiento = mov;
                        const ultimoMovimientoDetalle = mov.Detalles ? mov.Detalles[mov.Detalles.length - 1] : null;
                        if (ultimoMovimientoDetalle?.Saldo == 0) {
                            movPagoOnlineTemporal.Saldo = 0; // Si el último movimiento tiene saldo 0, se asigna el mismo saldo al movimiento de pago online para que no afecte al saldo total
                        }
                        mov.Detalles.push(movPagoOnlineTemporal);
                    }
                    mov.Periodo = this.GetStrPeriodo(mov.FechaInicio, mov.FechaFin);
                    mov.Detalles
                        ?.forEach((detalle: IMovimientoDetalle) => {
                            // detalle.ParentMovimiento = mov;
                            if (detalle.Categoria == CCategoriaMov.Comision) {
                                const prefTag = UIUtilViewData._GetStr_CategoriaMovimiento(detalle.Categoria);
                                const detalleComision = detalle.TipoValorComisionPlantilla == CTipoValor.Porcentaje
                                    ? UIUtilFormat._PercentFmt(detalle.ValorComisionPlantilla * 100)
                                    : UIUtilFormat._CurrencyFmt(detalle.ValorComisionPlantilla)
                                detalle.Cargo = `${prefTag}: ${detalle.Cargo} (${detalleComision})`
                            }
                            if (_DICC_ALUMNO_MOVPAGO_FOLIO.has(detalle.FolioPago)) {
                                let agrupadorMovs: IMovimientoDetalle[] = agrupadorMovsPagosFolioPagoOnline.get(detalle.FolioPago);
                                if (!agrupadorMovs) {
                                    agrupadorMovs = [];
                                    agrupadorMovsPagosFolioPagoOnline.set(detalle.FolioPago, agrupadorMovs);
                                }
                                agrupadorMovs.push(detalle);
                            }
                        })
                });
            movimientosRes.forEach(mov => {
                mov.Detalles?.forEach((detalle: IMovimientoDetalle) => {
                    detalle.PagosMovRelacionados = (agrupadorMovsPagosFolioPagoOnline.get(detalle.FolioPago) || [])
                        .filter(d => d.Id != detalle.Id);
                });
            });
        } else {
            this.ctrlNotification._Mostrar(this.CARDCOLL_GetUIStringModule("tag_fail_getmovs"), "ADVERTENCIA");
        }
        // console.warn(this.movimientosMap, movimientosRes, "GetListaMovimientos");
        return (res.Resultado > 0);
    }
}

function EvalGenerarCFDIAction(opciones: Table.ITableMenuDataSelectedOptionConfig<IMovimiento>[], escuela: Entidad.IEscuela, idAlumno: number, onEndProccess: () => void, movimientos?: IMovimiento[]) {
    const idsMovsPagos = GetIdsPagosMovimientos(movimientos || [])
    if ((!movimientos || !!idsMovsPagos.length) && escuela.UsaFactura) {
        opciones.push({
            Label: _L("panelfinanzasedocuenta.action_genera_cfdi"),
            Callback: () => UIUtilViewAlumnoEdoCtaFacturacion._OpenModal_GeneraCFDI(escuela.IdKinder, idAlumno, onEndProccess, idsMovsPagos)
        })
    }
}

/* function HasMovimientosPagos(movimientos: IMovimiento[]) {
    const tipoPago = [CTipoPago.PagoParcial, CTipoPago.PagoCompleto]
    return movimientos.some(mov => {
        return mov.Detalles
            .some(det => tipoPago.includes(det.Categoria as unknown as CTipoPago))
    })
} */

function GetIdsPagosMovimientos(movimientos: IMovimiento[]) {
    const tipoPago = [CTipoPago.PagoParcial, CTipoPago.PagoCompleto]
    const ids: number[] = []
    movimientos.forEach(mov => {
        return mov.Detalles.forEach(det => {
            const esPago = tipoPago.includes(det.Categoria as unknown as CTipoPago)
            if (!esPago) return
            ids.push(det.Id)
        })
    })
    return ids
}

//#endregion